module.exports = __webpack_public_path__ + "static/fonts/BMEULJIRO.otf?0cbe8592";